const SIGNUP_CREDIT_AWARD_STORAGE_KEY = 'pending_signup_credit_award';

export const SIGNUP_CREDIT_AWARD_EVENT = 'signup-credit-award-queued';

export const parseSignupCreditAward = (value: unknown): number | null => {
  if (typeof value !== 'number' && typeof value !== 'string') return null;

  const amount = typeof value === 'number' ? value : Number(value.trim());

  return Number.isFinite(amount) && amount > 0 ? amount : null;
};

export const queueSignupCreditAward = (value: unknown, notify = false): number | null => {
  const amount = parseSignupCreditAward(value);

  if (amount === null) return null;

  sessionStorage.setItem(SIGNUP_CREDIT_AWARD_STORAGE_KEY, String(amount));

  if (notify) window.dispatchEvent(new Event(SIGNUP_CREDIT_AWARD_EVENT));

  return amount;
};

export const consumeSignupCreditAward = (): number | null => {
  const raw = sessionStorage.getItem(SIGNUP_CREDIT_AWARD_STORAGE_KEY);

  sessionStorage.removeItem(SIGNUP_CREDIT_AWARD_STORAGE_KEY);

  return parseSignupCreditAward(raw);
};

export const hasPendingCreditAward = (): boolean => (
  parseSignupCreditAward(sessionStorage.getItem(SIGNUP_CREDIT_AWARD_STORAGE_KEY)) !== null
);

export const queueSignupCreditAwardFromSearch = (search: string): number | null => (
  queueSignupCreditAward(new URLSearchParams(search).get('signup_credits_awarded'))
);
